import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../Styles/ResetPasswordAgency.css'; // Optional for styling

const ResetPasswordAgency = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newPassVisible, setNewPassVisible] = useState(false);
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [error, setError] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;

  if (!email) {
    return <p>Error: Email not provided</p>;
  }

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await axios.post(
        'https://b2bbackend.dxbhabibi.com/api/b2/agency/resetPassword',
        { email, newPassword },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        alert('Password reset successful!');
        navigate('/');
      } else {
        setError('Error resetting password');
      }
    } catch (err) {
      console.error(err);
      setError('Server error');
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-card">
        <h2>Admin Reset Password</h2>
        <form onSubmit={handleResetPassword}>
          <div className="form-group">
            <label>New Password</label>
            <div className="input-password-wrapper">
              <input
                type={newPassVisible ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button type="button" onClick={() => setNewPassVisible(!newPassVisible)}>
                {newPassVisible ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <div className="input-password-wrapper">
              <input
                type={confirmPassVisible ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button type="button" onClick={() => setConfirmPassVisible(!confirmPassVisible)}>
                {confirmPassVisible ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="reset-btn">Reset Password</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordAgency;
